import Axios from "axios";
import { API_URL } from "config";
import { useCentralStore } from "stores";
import { getToken } from "utils/getToken";

export const axios = Axios.create({
  baseURL: API_URL,
  headers: {
    Accept: "application/json"
  }
});

axios.interceptors.request.use(config => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = token;
  }
  return config;
});

axios.interceptors.response.use(
  response => response.data,
  error => {
    const { response } = error;
    const setNotification = useCentralStore.getState().setNotification;
    const openSignOutModal = useCentralStore.getState().openSignOutModal;

    if (
      response?.status === 401 &&
      window.location.pathname !== "/auth/sign-in"
    ) {
      openSignOutModal();
    }

    const errorMessage = response?.data?.errors;

    if (typeof errorMessage === "string") {
      if (errorMessage.includes("unauthorized") || response?.status === 403) {
        setNotification({
          type: "error",
          title: "Unauthorized",
          message: "You are unauthorized from performing this action."
        });
      } else if (response?.status === 500) {
        setNotification({
          type: "error",
          message:
            errorMessage || "Something went wrong. Please try again later."
        });
      }
    }

    return response
      ? Promise.reject(response.data)
      : Promise.reject(error.message);
  }
);
